export const CHANGE_TIER_NOTIFICATION = 'CHANGE_TIER_NOTIFICATION';
export const CHANGE_TIER_QUEUED_NOTIFICATION = 'CHANGE_TIER_QUEUED_NOTIFICATION';
export const CHANGED_PAYMENT_NOTIFICATION_SUCCESS = 'CHANGED_PAYMENT_NOTIFICATION_SUCCESS';
export const CHANGED_PAYMENT_NOTIFICATION_ERROR = 'CHANGED_PAYMENT_NOTIFICATION_ERROR';
export const PAYMENT_REMINDER_NOTIFICATION = 'PAYMENT_REMINDER_NOTIFICATION';
export const EMAIL_VERIFIED_NOTIFICATION = 'EMAIL_VERIFIED_NOTIFICATION';
export const EMAIL_ALREADY_EXISTS_NOTIFICATION = 'EMAIL_ALREADY_EXISTS_NOTIFICATION';
export const LOGOUT_ALL_DEVICES_SUCCESS = 'LOGOUT_ALL_DEVICES_SUCCESS';
export const LOGOUT_ALL_DEVICES_ERROR = 'LOGOUT_ALL_DEVICES_ERROR';
